import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  // Use the user state from AuthContext
  const { user } = useAuth();

  return user ? children : <Navigate to='/login' replace />;
};

export default PrivateRoute;
